// import { createCipher, createDecipher } from 'crypto'
import Swal from 'sweetalert2'

const crypto = require('crypto')

const algorithm = 'aes-256-ctr',
  // password = '564545454',
  // passlogin = 'v#@21%&258ase',
  key = 'b2df428b9929d3ace7c598bbf4e496bs'

/**
 * Encrypts string hex
 */
export const encrypt = (text) => {
  const nonce = crypto.randomBytes(16)
  const cipher = crypto.createCipheriv(algorithm, key, nonce, {
    authTagLength: 16
  })
  const ciphertext = cipher.update(text, 'utf8', 'hex')

  cipher.final()

  return { ciphertext, nonce }
}

export const swalConfirm = (data) => new Promise((resolve, reject) => {
  Swal.fire({
    title: (data.title ? data.title : 'Confirma a ação?'),
    text: (data.text ? data.text : 'A ação não poderá ser desfeita?'),
    type: (data.type ? data.type : 'warning'),
    showCancelButton: true,
    confirmButtonColor: (data.btnConfirmColor ? data.btnConfirmColor : '#B71C1C'),
    cancelButtonColor: '#03A9F4',
    confirmButtonText: (data.btnConfirmText ? data.btnConfirmText : 'Excluir'),
    cancelButtonText: (data.btnCancelText ? data.btnCancelText : 'Cancelar')
  }).then((result) => {
    if (result.value) {
      return resolve()
    }

    return reject()
  })
})

// const algorithm = 'aes-256-ctr'
// const password = '564545454'
// const passlogin = 'v#@21%&258ase'
//
// /**
//  * Encrypts string hex
//  */
// export const encrypt = (str, opt) => {
//   if (!str) {
//     return false
//   }
//   let cipher = createCipher(algorithm, opt === true ? passlogin : password)
//   let crypted = cipher.update(str, 'utf8', 'hex')
//   crypted += cipher.final('hex')
//   return crypted
// }
//
//
// /**
//  * Decrypts string hex
//  */
// /*
// export const decrypt = (str, opt) => {
//   let decipher = createDecipher(algorithm, opt === true ? passlogin : password)
//   let dec = decipher.update(str, 'hex', 'utf8')
//   dec += decipher.final('utf8')
//   return dec
// }
// */
//
export const convertImage = (file) => new Promise((resolve, reject) => {
  if (!file) {
    return resolve(null)
  }
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => { return resolve(reader.result) }
  reader.onerror = error => { return reject(error) }
})

export const defaultCourseImage = 'data:image/png;base64,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'

export const gradeTypes = [
  { _id: '58862a828f3e2721f8d920c7', name: '3 Anos Infantil', order: 10 },
  { _id: '58862a828f3e2721f8d920c5', name: '4 Anos Infantil', order: 20 },
  { _id: '58862a828f3e2721f8d920c6', name: '5 Anos Infantil', order: 30 },
  { _id: '58862a828f3e2721f8d920bc', name: '1º Ano Fundamental', order: 40 },
  { _id: '58862a828f3e2721f8d920bd', name: '2º Ano Fundamental', order: 50 },
  { _id: '58862a828f3e2721f8d920be', name: '3º Ano Fundamental', order: 60 },
  { _id: '58862a828f3e2721f8d920bf', name: '4º Ano Fundamental', order: 70 },
  { _id: '58862a828f3e2721f8d920c0', name: '5º Ano Fundamental', order: 80 },
  { _id: '58862a828f3e2721f8d920c1', name: '6º Ano Fundamental', order: 90 },
  { _id: '58862a828f3e2721f8d920c2', name: '7º Ano Fundamental', order: 100 },
  { _id: '58862a828f3e2721f8d920c3', name: '8º Ano Fundamental', order: 110 },
  { _id: '58862a828f3e2721f8d920c4', name: '9º Ano Fundamental', order: 120 },
  { _id: '58862a828f3e2721f8d920c8', name: '1º Ano Ensino Medio', order: 130 },
  { _id: '58862a828f3e2721f8d920c9', name: '2º Ano Ensino Medio', order: 140 },
  { _id: '58862a828f3e2721f8d920ca', name: '3º Ano Ensino Medio', order: 150 }
]

export const priceDivider = (price) => {
  let value = '',
    cents = ''

  if (price) {
    const arr = String(price).split('.')

    value = arr[0]
    cents = arr[1].padEnd(2, '0')
  }

  return { value, cents }
}

export const numberFormat = (number, decimals, decPoint, thousandsSep) => {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s

  let toFixedFix = function (n, prec) {
    if (('' + n).indexOf('e') === -1) {
      return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
    } else {
      let arr = ('' + n).split('e')
      let sig = ''
      if (+arr[1] + prec > 0) {
        sig = '+'
      }
      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
    }
  }

  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }

  return s.join(dec)
}

export const isValidCPF = (cpf) => {
  if (typeof cpf !== 'string') return false
  cpf = cpf.replace(/[\s.-]*/igm, '')
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false
  }
  let soma = 0
  let resto
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(cpf.substring(9, 10))) return false
  soma = 0
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  return resto === parseInt(cpf.substring(10, 11))
}

export const isValidCNPJ = (s) => {
  if (typeof s !== 'string') return false
  let cnpj = s.replace(/[^\d]+/g, '')

  // Valida a quantidade de caracteres
  if (cnpj.length !== 14)
    return false

  // Elimina inválidos com todos os caracteres iguais
  if (/^(\d)\1+$/.test(cnpj))
    return false

  // Cáculo de validação
  let t = cnpj.length - 2,
    d = cnpj.substring(t),
    d1 = parseInt(d.charAt(0)),
    d2 = parseInt(d.charAt(1)),
    calc = x => {
      let n = cnpj.substring(0, x),
        y = x - 7,
        s = 0,
        r = 0

      for (let i = x; i >= 1; i--) {
        s += n.charAt(x - i) * y--
        if (y < 2)
          y = 9
      }

      r = 11 - s % 11
      return r > 9 ? 0 : r
    }

  return calc(t) === d1 && calc(t + 1) === d2
}

export const states = [
  { uf: 'AC', name: 'Acre' },
  { uf: 'AL', name: 'Alagoas' },
  { uf: 'AP', name: 'Amapá' },
  { uf: 'AM', name: 'Amazonas' },
  { uf: 'BA', name: 'Bahia' },
  { uf: 'CE', name: 'Ceará' },
  { uf: 'DF', name: 'Distrito Federal' },
  { uf: 'ES', name: 'Espírito Santo' },
  { uf: 'GO', name: 'Goiás' },
  { uf: 'MA', name: 'Maranhão' },
  { uf: 'MT', name: 'Mato Grosso' },
  { uf: 'MS', name: 'Mato Grosso do Sul' },
  { uf: 'MG', name: 'Minas Gerais' },
  { uf: 'PA', name: 'Pará' },
  { uf: 'PB', name: 'Paraíba' },
  { uf: 'PR', name: 'Paraná' },
  { uf: 'PE', name: 'Pernambuco' },
  { uf: 'PI', name: 'Piauí' },
  { uf: 'RJ', name: 'Rio de Janeiro' },
  { uf: 'RN', name: 'Rio Grande do Norte' },
  { uf: 'RS', name: 'Rio Grande do Sul' },
  { uf: 'RO', name: 'Rondônia' },
  { uf: 'RR', name: 'Roraima' },
  { uf: 'SC', name: 'Santa Catarina' },
  { uf: 'SP', name: 'São Paulo' },
  { uf: 'SE', name: 'Sergipe' },
  { uf: 'TO', name: 'Tocantins' }
]

export const months = [
  { number: '01', text: 'Janeiro' },
  { number: '02', text: 'Fevereiro' },
  { number: '03', text: 'Março' },
  { number: '04', text: 'Abril' },
  { number: '05', text: 'Maio' },
  { number: '06', text: 'Junho' },
  { number: '07', text: 'Julho' },
  { number: '08', text: 'Agosto' },
  { number: '09', text: 'Setembro' },
  { number: '10', text: 'Outubro' },
  { number: '11', text: 'Novembro' },
  { number: '12', text: 'Dezembro' }
]
